var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgKeypointDelete = function SvgKeypointDelete(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.74268 12C2.74268 13.2426 3.74268 14.2426 5.74268 16.2426L7.75739 18.2574C9.75739 20.2574 10.7574 21.2574 12 21.2574C13.2427 21.2574 14.2427 20.2574 16.2427 18.2574L18.2574 16.2426C20.2574 14.2426 21.2574 13.2426 21.2574 12C21.2574 10.7574 20.2574 9.75736 18.2574 7.75736L16.2427 5.74265C14.2427 3.74265 13.2427 2.74265 12 2.74265C10.7574 2.74265 9.75739 3.74265 7.75739 5.74265L5.74268 7.75736C3.74268 9.75736 2.74268 10.7574 2.74268 12ZM8 11C7.44771 11 7 11.4477 7 12C7 12.5523 7.44771 13 8 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H8Z",
    fill: "#DD0000"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKeypointDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "keypoint-delete.768d3926e919459a61e9226c7e2f2117.svg";